<template>
  <v-dialog v-model="dialog" persistent max-width="650px">
    <v-card class="approve-actions-dialog-root" @mousedown="onApproveFormMouseDown">
      <v-card-title class="redColor text-white">
        <v-row class="pa-3">
          <span class="headline">
            {{ $t("leko_employees.approve_parts.form.approve_part") }}
          </span>
          <!---------------------------------AUTOBOT BUTTON CODE--------------------------------->
          <v-spacer></v-spacer>
          <v-btn
            v-if="
              $store.getters.role === 'SuperAdmin' &&
              part.car_id != null &&
              part.car_id != ''
            "
            variant="outlined"
            icon
            size="small"
            color="white"
            :loading="loading"
            class="mx-1"
            @click="autoBotApi(part)"
          >
            <v-icon> mdi-robot </v-icon>
          </v-btn>
          <!---------------------------------CLOSE BUTTON CODE--------------------------------->
          <v-btn
            variant="outlined"
            icon
            size="small"
            color="white"
            @click="close"
          >
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-alert
          v-model="alert.value"
          :type="alert.type"
          variant="outlined"
          class="mt-3"
        >
          {{ $t(alert.message) }}
        </v-alert>
        <v-alert
          v-if="lockConflict"
          type="warning"
          variant="tonal"
          class="mt-3"
          icon="mdi-lock-alert"
        >
          {{ $t('leko_employees.approve_parts.form.part_locked_by') }}
          <strong>{{ lockConflict.lockedBy.name }} {{ lockConflict.lockedBy.surname }}</strong>
          ({{ new Date(lockConflict.lockedAt).toLocaleTimeString() }})
        </v-alert>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container grid-list-md>
            <v-row row wrap>
              <!---------------------------------MANUFACTURER CODE--------------------------------->
              <v-col xs="6" md="6" lg="6">
                <v-text-field
                  v-model="part.manufacturer_code"
                  :label="
                    $t('leko_employees.approve_parts.form.manufacturer_code')
                  "
                  :loading="loadingManufacturer"
                  color="red-darken-1"
                  append-inner-icon="mdi-find-replace"
                  @keyup.enter="searchByManufacturer()"
                  @click:append-inner="searchByManufacturer()"
                />
              </v-col>
              <!-----------------------------------INFOCAR CODE------------------------------------>
              <v-col xs="6" md="6" lg="6">
                <!--TEXTFIELD-->
                <v-text-field
                  v-model.trim="infoCarCode"
                  :color="found ? 'success' : 'error'"
                  :append-inner-icon="
                    found
                      ? 'mdi-check-circle-outline'
                      : 'mdi-alert-circle-outline'
                  "
                  :label="$t('leko_employees.approve_parts.form.info_car_code')"
                  :loading="loadingInfoCar"
                  :disabled="customInfoCarTitle"
                  @keyup.enter="searchCode()"
                  @click:append-inner="searchCode()"
                />
              </v-col>
              <!----------------------------------INFOCAR RESULT----------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-select
                  v-model="selectedInfoCar"
                  :items="infoCarResult"
                  :disabled="!found"
                  item-value="_id"
                  :filter="() => true"
                  :item-title="`description.descriptionId.title.${$store.getters.language}`"
                  :label="
                    $t('leko_employees.approve_parts.form.info_car_result')
                  "
                  color="red-darken-1"
                  return-object
                >
                  <template #item="{ props, item }">
                    <v-list-item v-bind="props">
                      <v-list-item-title>
                        {{ item.raw.oemCode }} -
                        {{
                          item.raw.description.descriptionId
                            ? item.raw.description.descriptionId.category.it
                            : ""
                        }}
                        :
                        {{
                          item.raw.description.descriptionId
                            ? item.raw.description.descriptionId.title.it
                            : ""
                        }}
                        -
                        {{
                          item.raw.description
                            ? getPosition(item.raw.description.positionCode)
                            : ""
                        }}
                      </v-list-item-title>
                    </v-list-item>
                  </template>

                  <template #selection="{ item }">
                    {{ item.raw.oemCode }} -
                    {{
                      item.raw.description.descriptionId
                        ? item.raw.description.descriptionId.category.it
                        : ""
                    }}
                    :
                    {{
                      item.raw.description.descriptionId
                        ? item.raw.description.descriptionId.title.it
                        : ""
                    }}-
                    {{
                      item.raw.description
                        ? getPosition(item.raw.description.positionCode)
                        : ""
                    }}
                  </template>
                </v-select>
                <v-alert
                  v-if="infoCarResult && infoCarResult.length > 1"
                  variant="tonal"
                  type="warning"
                  borer="bottom"
                >
                  {{ $t("select_position") }}
                </v-alert>
                <v-row
                  v-if="
                    selectedInfoCar &&
                    selectedInfoCar.applicability &&
                    selectedInfoCar.applicability.length == 0 &&
                    selectedInfoCar.metadata &&
                    selectedInfoCar.metadata.length == 0
                  "
                >
                  <v-col xs="12" sm="12" xl="12" lg="12" md="12">
                    <v-alert variant="tonal" type="warning" borer="bottom">
                      {{ $t("set_custom_applicability") }}
                    </v-alert></v-col
                  >
                  <v-col xs="12" sm="6" xl="6" lg="6" md="6">
                    <v-autocomplete
                      v-model="brand"
                      :items="brands"
                      :loading="loadingBrand"
                      :label="$t('parts.advanced_search.brand')"
                      item-title="title"
                      variant="solo"
                      color="red-darken-1"
                      hide-details
                      return-object
                      clearable
                    >
                      <!-- Custom dropdown item -->
                      <template #item="{ props, item }">
                        <v-list-item v-bind="props">
                          <template #prepend>
                            <v-img
                              :src="item.raw.logo"
                              height="35"
                              width="35"
                              class="mr-3"
                              cover
                            />
                          </template>
                          <!-- <v-list-item-title>{{ item.raw.title }}</v-list-item-title> -->
                        </v-list-item>
                      </template>

                      <!-- Selected value in the field -->
                      <template #selection="{ item }">
                        <div class="d-flex align-center">
                          <v-img
                            :src="item.raw.logo"
                            height="35"
                            width="35"
                            class="mr-3"
                            cover
                          />
                          <span>{{ item.raw.title }}</span>
                        </div>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    xs="12"
                    sm="12"
                    :xl="model ? '12' : '6'"
                    :lg="model ? '12' : '6'"
                    :md="model ? '12' : '6'"
                  >
                    <v-combobox
                      v-model="model"
                      :items="models"
                      :loading="loadingModel"
                      :label="!model ? $t('parts.advanced_search.model') : ''"
                      item-title="description"
                      item-value="modelCode"
                      variant="solo"
                      color="red-darken-1"
                      hide-details
                      return-object
                      clearable
                      class="car-search-combobox"
                      @click:append-inner="model = null"
                    >
                      <!-- Dropdown items -->
                      <template #item="{ props, item }">
                        <v-list-item v-bind="props">
                          <v-list-item-content>
                            <v-row>
                              <!-- Description -->
                              <v-col
                                cols="12"
                                md="4"
                                class="bg-grey-lighten-3 mt-2"
                              >
                                <div class="d-flex flex-column">
                                  <span class="caption">{{
                                    $t("parts.advanced_search.model")
                                  }}</span>
                                  <span class="font-weight-bold">{{
                                    item.raw.description
                                  }}</span>
                                </div>
                              </v-col>

                              <!-- Year range -->
                              <v-col
                                cols="12"
                                md="8"
                                class="bg-grey-lighten-3 mt-2"
                              >
                                <div class="d-flex flex-column">
                                  <span class="caption">{{
                                    $t("parts.advanced_search.year")
                                  }}</span>
                                  <span class="font-weight-bold">
                                    {{ formatMonthYear(item.raw.startingDate) }}
                                    -
                                    {{ formatMonthYear(item.raw.endingDate) }}
                                  </span>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item-content>
                        </v-list-item>
                      </template>

                      <!-- Selected value -->
                      <template #selection="{ item }">
                        <div
                          class="car-detail-selection d-flex justify-between align-center pa-2 w-100"
                        >
                          <div class="car-detail-col d-flex flex-column pr-2">
                            <span class="caption">{{
                              $t("parts.advanced_search.model")
                            }}</span>
                            <span class="font-weight-bold">{{
                              item.raw.description
                            }}</span>
                          </div>
                          <div class="car-detail-col d-flex flex-column">
                            <span class="caption">{{
                              $t("parts.advanced_search.year")
                            }}</span>
                            <span class="font-weight-bold">
                              {{ formatMonthYear(item.raw.startingDate) }} -
                              {{ formatMonthYear(item.raw.endingDate) }}
                            </span>
                          </div>
                        </div>
                      </template>
                    </v-combobox>
                  </v-col>
                  <v-col xs="12" sm="12" xl="12" lg="12" md="12">
                    <v-combobox
                      v-model="version"
                      :items="versions"
                      :loading="loadingVersion"
                      :label="
                        !version ? $t('parts.advanced_search.version') : ''
                      "
                      item-title="fullDescription"
                      item-value="versionCode"
                      variant="solo"
                      color="red-darken-1"
                      hide-details
                      return-object
                      clearable
                      class="car-search-combobox car-search-version-combobox"
                      @click:append-inner="version = null"
                    >
                      <!-- Dropdown items -->
                      <template #item="{ item, props }">
                        <v-list-item v-bind="props">
                          <div
                            class="d-sm-none car-version-detail-item bg-grey-lighten-3 mt-2 pa-3 w-100"
                          >
                            <div
                              class="car-version-detail-row car-version-detail-row--dropdown"
                            >
                              <div
                                class="car-version-detail-col car-version-detail-col--main"
                              >
                                <span class="caption">{{
                                  $t("parts.advanced_search.version")
                                }}</span>&nbsp;
                                <span class="font-weight-bold">{{
                                  item.raw.description
                                }}</span>
                              </div>
                              <div class="car-version-detail-col">
                                <span class="caption">{{
                                  $t("parts.advanced_search.year")
                                }}</span>&nbsp;
                                <span class="font-weight-bold">
                                  {{ formatMonthYear(item.raw.startingDate) }} -
                                  {{ formatMonthYear(item.raw.endingDate) }}
                                </span>
                              </div>
                              <div class="car-version-detail-col">
                                <span class="caption">{{
                                  $t("parts.advanced_search.body")
                                }}</span>&nbsp;
                                <span class="font-weight-bold">{{
                                  item.raw.numberOfDoors
                                }}</span>
                              </div>
                              <div class="car-version-detail-col">
                                <span class="caption">{{
                                  $t("parts.advanced_search.power")
                                }}</span>&nbsp;
                                <span class="font-weight-bold">
                                  {{ item.raw.power ? item.raw.power.kw : "" }}
                                  kw,
                                </span>
                              </div>
                              <div class="car-version-detail-col">
                                <span class="caption">{{
                                  $t("parts.advanced_search.engine")
                                }}</span>&nbsp;
                                <span class="font-weight-bold">{{
                                  item.raw.engineCode
                                }}</span>
                              </div>
                              <div class="car-version-detail-col">
                                <span class="caption">{{
                                  $t("parts.advanced_search.supply.supply")
                                }}</span>&nbsp;
                                <span class="font-weight-bold">{{
                                  getSupplyLocale(item.raw.supplyCode)
                                }}</span>
                              </div>
                            </div>
                          </div>
                    <v-row class="d-none d-sm-flex pa-3 bg-grey-lighten-3 mt-2">
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.version")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.description
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.year")
                          }}</span>
                          <span class="font-weight-bold">
                            {{ formatMonthYear(item.raw.startingDate) }} -
                            {{ formatMonthYear(item.raw.endingDate) }}
                          </span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.body")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.numberOfDoors
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.power")
                          }}</span>
                          <span class="font-weight-bold">
                            {{ item.raw.power ? item.raw.power.kw : "" }} kw,
                          </span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.engine")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.engineCode
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.supply.supply")
                          }}</span>
                          <span class="font-weight-bold">{{
                            getSupplyLocale(item.raw.supplyCode)
                          }}</span>
                        </v-row>
                      </v-col>
                    </v-row>
                        </v-list-item>
                      </template>

                      <!--SELECTED-->
                      <template #selection="{ item }">
                        <div
                          class="car-version-detail-selection car-detail-selection w-100 d-sm-none"
                        >
                          <div class="car-version-detail-row">
                            <div
                              class="car-version-detail-col car-version-detail-col--main"
                            >
                              <span class="caption">
                                {{ $t("parts.advanced_search.version") }}
                              </span>
                              <span class="font-weight-bold">{{
                                item.raw.description
                              }}</span>
                            </div>
                            <div class="car-version-detail-col">
                              <span class="caption">{{
                                $t("parts.advanced_search.year")
                              }}</span>
                              <span class="font-weight-bold">
                                {{ formatMonthYear(item.raw.startingDate) }} -
                                {{ formatMonthYear(item.raw.endingDate) }}
                              </span>
                            </div>
                            <div class="car-version-detail-col">
                              <span class="caption">{{
                                $t("parts.advanced_search.body")
                              }}</span>
                              <span class="font-weight-bold">{{
                                item.raw.numberOfDoors
                              }}</span>
                            </div>
                            <div class="car-version-detail-col">
                              <span class="caption">{{
                                $t("parts.advanced_search.power")
                              }}</span>
                              <span class="font-weight-bold">
                                {{ item.raw.power ? item.raw.power.kw : " " }}
                                kw,
                              </span>
                            </div>
                            <div class="car-version-detail-col">
                              <span class="caption">{{
                                $t("parts.advanced_search.engine")
                              }}</span>
                              <span class="font-weight-bold">{{
                                item.raw.engineCode
                              }}</span>
                            </div>
                            <div class="car-version-detail-col">
                              <span class="caption">{{
                                $t("parts.advanced_search.supply.supply")
                              }}</span>
                              <span class="font-weight-bold">{{
                                getSupplyLocale(item.raw.supplyCode)
                              }}</span>
                            </div>
                          </div>
                        </div>
                  <v-row class="pa-2 d-none d-sm-flex">
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">
                          {{ $t("parts.advanced_search.version") }}
                        </span>
                        <span class="font-weight-bold">{{
                          item.raw.description
                        }}</span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.year")
                        }}</span>
                        <span class="font-weight-bold">
                          {{ formatMonthYear(item.raw.startingDate) }} -
                          {{ formatMonthYear(item.raw.endingDate) }}
                        </span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.body")
                        }}</span>
                        <span class="font-weight-bold">{{
                          item.raw.numberOfDoors
                        }}</span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.power")
                        }}</span>
                        <span class="font-weight-bold">
                          {{ item.raw.power ? item.raw.power.kw : " " }} kw,
                        </span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.engine")
                        }}</span>
                        <span class="font-weight-bold">{{
                          item.raw.engineCode
                        }}</span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.supply.supply")
                        }}</span>
                        <span class="font-weight-bold">{{
                          getSupplyLocale(item.raw.supplyCode)
                        }}</span>
                      </v-row>
                    </v-col>
                  </v-row>
                      </template>
                    </v-combobox>
                  </v-col>
                  <v-col
                    xs="12"
                    sm="12"
                    xl="12"
                    lg="12"
                    md="12"
                    class="text-end justify-end d-flex"
                  >
                    <v-btn
                      color="green darken-1"
                      variant="flat"
                      class="mx-1"
                      :loading="loadingCustom"
                      @click="saveCustomApplicability"
                    >
                      {{ $t("save_custom_applicability") }}
                    </v-btn>
                  </v-col>
                  <v-alert
                    v-model="alert2.value"
                    :type="alert2.type"
                    variant="outlined"
                    class="mt-3"
                  >
                    {{ $t(alert2.message) }}
                  </v-alert>
                </v-row>
              </v-col>
              <!-----------------------------------CUSTOM TITLE------------------------------------>
              <v-col xs="12" md="12" lg="12">
                <v-menu
                  v-model="customInfoCarTitleMenuOpen"
                  :persistent="pinCustomInfoCarTitleMenu"
                  location="bottom"
                  max-height="300"
                  :close-on-content-click="true"
                >
                  <template #activator="{ props: activatorProps }">
                    <v-text-field
                      ref="customInfoCarTitleField"
                      v-bind="activatorProps"
                      v-model="searchInfoCarTitle"
                      :loading="loadingCustomInfoCarTitle"
                      :label="
                        $t(
                          'leko_employees.approve_parts.form.info_car_custom_title',
                        )
                      "
                      :disabled="found"
                      color="red-darken-1"
                      :append-inner-icon="
                        customInfoCarTitle === null
                          ? 'mdi-magnify'
                          : 'mdi-keyboard-backspace'
                      "
                      @click:append-inner="clearCustomInfoCarTitle"
                      @focus="onCustomInfoCarTitleFocus"
                      @keydown="onCustomInfoCarTitleKeydown"
                    />
                  </template>
                  <v-list
                    v-if="infoCarTitles.length"
                    density="compact"
                    style="top: -20px !important"
                    class="my-0 py-0 custom-info-car-title-menu"
                  >
                    <v-list-item
                      v-for="item in infoCarTitles"
                      :key="item.partCode || item._id"
                      @click="selectCustomInfoCarTitle(item)"
                    >
                      <v-list-item-title>
                        <span
                          v-html="
                            highlightInfoCarTitle(
                              item.title?.[$store.getters.language],
                              searchInfoCarTitle,
                            )
                          "
                        />
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <!----------------------------------CUSTOM TITLE POSITION---------------------------->
              <v-col v-if="customInfoCarTitle" xs="12" md="12" lg="12">
                <v-select
                  v-model="customInfoCarPosition"
                  :items="customInfoCarPositionItems"
                  :label="$t('leko_employees.approve_parts.form.part_position')"
                  :hint="$t('leko_employees.approve_parts.form.part_position_hint')"
                  persistent-hint
                  color="red-darken-1"
                  class="custom-info-car-position"
                />
              </v-col>
              <!-------------------------------------OEM CODES------------------------------------->
              <v-col>
                <v-text-field
                  v-model="oemCode"
                  :label="$t('leko_employees.approve_parts.form.oem_code')"
                  color="red-darken-1"
                  append-inner-icon="mdi-plus"
                  @keyup.enter="addOemCode()"
                  @click:append-inner="addOemCode()"
                />
              </v-col>
              <v-col v-if="part.oemCodes && part.oemCodes.length > 0">
                <div class="caption grey--text text--darken-1">
                  {{ $t("leko_employees.approve_parts.form.oem_codes") }}
                </div>
                <v-chip v-for="(item, index) in part.oemCodes" :key="index">
                  {{ item }}
                  <v-icon right @click="removeOemCode(index)">
                    mdi-minus-circle-outline
                  </v-icon>
                </v-chip>
              </v-col>
              <!---------------------------------------NOTES--------------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="part.notes"
                  :label="$t('leko_employees.approve_parts.form.notes')"
                  color="red-darken-1"
                  disabled
                />
              </v-col>
              <!--------------------------------------WARRANTY------------------------------------->
              <v-col xs="6" md="6" lg="6">
                <v-text-field
                  v-if="part.warranty_id"
                  v-model="warrantyValue"
                  :label="$t('leko_employees.approve_parts.form.warranty')"
                  color="red-darken-1"
                  disabled
                />
                <v-text-field
                  v-else
                  :label="$t('leko_employees.approve_parts.form.warranty')"
                  color="red-darken-1"
                  disabled
                />
              </v-col>
              <!---------------------------------------PRICE--------------------------------------->
              <v-col xs="6" md="6" lg="6">
                <v-text-field
                  v-model="priceAndCurrency"
                  :label="$t('leko_employees.approve_parts.form.price')"
                  color="red-darken-1"
                  disabled
                />
              </v-col>
              <!--------------------------------------QUALITY-------------------------------------->
              <v-col xs="6" md="6" lg="6">
                <v-row justify-center>
                  <v-chip>
                    <v-rating
                      v-if="part.quality"
                      v-model="part.quality.rating"
                      color="red"
                      background-color="red"
                      readonly
                    />
                  </v-chip>
                </v-row>
              </v-col>
              <!--------------------------------------CONDITION--------------------------------------->
              <v-col cols="3" md="3" lg="3" class="part-export-col">
                <div class="part-export-field">
                  <div class="part-export-field__header">
                    {{ $t("leko_employees.approve_parts.form.condition") }}
                  </div>
                  <v-checkbox
                    v-model="part.isNewPart"
                    :label="$t('leko_employees.approve_parts.form.new')"
                    color="red-darken-3"
                    hide-details
                    density="compact"
                    class="part-export-field__checkbox"
                  />
                </div>
              </v-col>
              <!--------------------------------------EXPORT EBAY / RR--------------------------------------->
              <export-marketplaces
                v-model:export-ebay="part.exportEbay"
                v-model:rr-export="part.rrExport"
                force-ebay
                force-rr
                :part-institution-rr="!!part.institution_id?.rr"
                cols="3"
                md="3"
                lg="3"
              />
              <!-----------------------------------INTERNAL NOTES---------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="part.internal_notes"
                  :label="
                    $t('leko_employees.approve_parts.form.internal_notes')
                  "
                  color="red-darken-1"
                />
              </v-col>
              <!-------------------------------------LEKO NOTES------------------------------------>
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="part.leko_notes"
                  :label="$t('leko_employees.approve_parts.form.leko_notes')"
                  color="red-darken-1"
                />
              </v-col>
              <!-----------------------------------REFUSE REASON----------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="part.refusal_reason"
                  :label="
                    $t('leko_employees.approve_parts.form.refusal_reason')
                  "
                  color="red-darken-1"
                />
              </v-col>
              <!---------------------------------------TESTS--------------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-select
                  v-model="part.tests"
                  :items="tests"
                  :label="$t('leko_employees.approve_parts.form.tests')"
                  :hint="$t('leko_employees.approve_parts.form.tests_label')"
                  color="red-darken-1"
                  item-title="title"
                  item-value="title"
                  multiple
                  persistent-hint
                />
              </v-col>
              <!--------------------------------------IMAGES--------------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-container grid-list-sm fluid>
                  <v-btn
                    v-if="part && part.images && part.images.length > 0"
                    variant="outlined"
                    class="mb-2"
                    color="green-darken-4"
                    @click="viewAllImages(part)"
                  >
                    {{ $t("leko_employees.approve_parts.form.view_images") }}
                    <v-icon size="x-large" color="green" class="pointer" end>
                      mdi-image
                    </v-icon>
                  </v-btn>
                  <div
                    v-if="part.images && part.images.length > 0"
                    class="images-section position-relative"
                  >
                    <v-row
                      v-if="loadingImages"
                      class="images-loader ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="red-darken-1"
                      />
                    </v-row>
                    <v-row v-else class="d-flex" no-gutters>
                      <div
                        v-for="(image, index) in part.images"
                        :key="image.image"
                        class="shrink"
                      >
                        <v-card
                          flat
                          tile
                          draggable="true"
                          :data-index="index"
                          @dragstart="dragStartHandler"
                          @dragover.prevent
                          @drop="dropHandler"
                          @dragend="dragEndHandler"
                          @mouseenter="hoverIndex = index"
                          @mouseleave="hoverIndex = null"
                        >
                          <v-img
                            :src="`${server}/images/?q=${image.thumb}`"
                            width="150px"
                            aspect-ratio="1"
                            class="mx-1"
                          >
                            <template #placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey-lighten-2"
                                  size="24"
                                />
                              </v-row>
                            </template>
                            <v-row
                              v-if="hoverIndex === index"
                              class="ma-1 d-flex justify-space-between"
                            >
                              <v-icon
                                size="x-large"
                                class="pointer"
                                :color="
                                  isSelected(image)
                                    ? 'primary'
                                    : 'grey-darken-2'
                                "
                                @click="setSelectedImage(image)"
                              >
                                {{
                                  isSelected(image)
                                    ? "mdi-checkbox-marked-outline"
                                    : "mdi-checkbox-blank-outline"
                                }}
                              </v-icon>

                              <v-icon
                                size="x-large"
                                color="orange"
                                class="pointer"
                                @click="
                                  viewImage({ type: 'string', data: image })
                                "
                              >
                                mdi-image
                              </v-icon>
                            </v-row>
                          </v-img>
                        </v-card>
                      </div>
                    </v-row>
                  </div>
                </v-container>
              </v-col>

              <!----------------------------------------------------------------------------------->
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-col class="pa-3" md="12" lg="12" xs="12">
        <v-alert v-model="alert1.value" :type="alert1.type">
          {{ $t(alert1.message) }}
        </v-alert>
      </v-col>
      <!------------------------------------------ACTIONS------------------------------------------>
      <v-card-actions>
        <v-row no-gutters>
          <v-spacer v-if="$vuetify.display.smAndUp" />
          <!--CLOSE-->
          <v-btn
            color="red-darken-1"
            variant="outlined"
            class="mx-1"
            @click="close"
          >
            {{ $t("leko_employees.approve_parts.form.close") }}
          </v-btn>
          <!--REFUSE-->
          <!--
          v-if="!part.kit
          || (part.kit && part.kit === false)
          || (part.kit && part.kit === true && part.kit_main_part && part.kit_main_part === true)"
          -->

          <v-btn
            :disabled="!part.refusal_reason || !!lockConflict"
            :loading="loadingRefuse"
            color="error"
            variant="outlined"
            class="mx-1"
            @click="refuse"
          >
            {{ $t("leko_employees.approve_parts.form.refuse") }}
          </v-btn>
          <!--REVIEW-->
          <!--
          v-if="!part.kit
          || (part.kit && part.kit === false)
          || (part.kit && part.kit === true && part.kit_main_part && part.kit_main_part === true)"
          -->
          <v-btn
            :disabled="!!lockConflict"
            :loading="loadingReview"
            color="warning"
            variant="outlined"
            class="mx-1"
            @click="review"
          >
            {{ $t("leko_employees.approve_parts.form.review") }}
          </v-btn>
          <!--SAVE-->
          <v-btn
            :disabled="!!lockConflict"
            color="green darken-1"
            variant="outlined"
            class="mx-1"
            @click="save"
          >
            {{ $t("leko_employees.approve_parts.form.save") }}
          </v-btn>
          <!--APPROVE-->
          <!--
          v-if="!part.kit
          || (part.kit && part.kit === false)
          || (part.kit && part.kit === true && part.kit_main_part && part.kit_main_part === true)"
          -->
          <v-btn
            :disabled="(!found && !selectedInfoCar) || !!lockConflict"
            :loading="loadingApprove"
            color="success"
            variant="outlined"
            class="mx-1"
            @click="approve"
          >
            {{ $t("leko_employees.approve_parts.form.approve") }}
          </v-btn>
        </v-row>
      </v-card-actions>
      <!------------------------------------------------------------------------------------------->
      <v-card-actions />
    </v-card>
  </v-dialog>
</template>

<script>
import getRequest from "../../api/getRequest";
import postRequest from "../../api/postRequest";
import putRequest from "../../api/putRequest";
import deleteRequest from "../../api/deleteRequest";
import { useDisplay } from "vuetify";
import ExportMarketplaces from "@/components/common/ExportMarketplaces.vue";

export default {
  components: {
    "export-marketplaces": ExportMarketplaces,
  },
  props: ["hide"], // eslint-disable-line vue/require-prop-types
  data: () => ({
    dialog: false,
    valid: false,
    found: false,
    loading: false,
    loadingManufacturer: false,
    loadingInfoCar: false,
    loadingApprove: false,
    loadingRefuse: false,
    loadingReview: false,
    loadingSave: false,
    loadingCustomInfoCarTitle: false,
    infoCarCode: null,
    infoCarResult: [],
    selectedInfoCar: null,
    oemCode: null,
    customInfoCarTitle: null,
    customInfoCarPosition: "S000",
    searchInfoCarTitle: null,
    infoCarTitles: [],
    selectedImage: null,
    part: {},
    tests: [],
    alert: {
      value: false,
      message: "",
      type: "error",
    },
    alert1: {
      value: false,
      message: "",
      type: "error",
    },
    alert2: {
      value: false,
      message: "",
      type: "error",
    },
    imageUrl: null,
    hoverIndex: null,
    draggingIndex: -1,
    dropIndex: -1,
    brand: null,
    model: null,
    version: null,
    brands: [],
    models: [],
    versions: [],
    loadingBrand: false,
    loadingModel: false,
    loadingVersion: false,
    loadingCustom: false,
    loadingImages: false,
    customInfoCarTitleMenuOpen: false,
    pinCustomInfoCarTitleMenu: false,
    suppressCustomInfoCarTitleSearch: false,
    isEditing: false,
    lockConflict: null,
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
    priceAndCurrency() {
      if (this.part.price && this.part.currency) {
        return `${this.part.price} ${this.part.currency}`;
      }
      return "";
    },
    warrantyValue() {
      if (this.part.warranty_id) {
        return `${parseInt(this.part.warranty_id.return_days, 10) / 86400} ${this.$t("warranties.days")}`;
      }
      return "";
    },
    hideDialog() {
      return this.$props.hide;
    },
    display() {
      return useDisplay();
    },
    // LekoAdmin / SuperAdmin may review without taking a lock. LekoEmployee
    // (and LekoBot) still lock so two employees cannot edit the same part.
    locksApprovePart() {
      const role = this.$store.getters.role;
      return role !== "LekoAdmin" && role !== "SuperAdmin";
    },
    customInfoCarPositionItems() {
      return [
        {
          title:
            this.$t("neutral").charAt(0).toUpperCase() +
            this.$t("neutral").slice(1),
          value: "S000",
        },
        { title: "SX", value: "S001" },
        { title: "DX", value: "S002" },
      ];
    },
  },
  watch: {
    hideDialog(value) {
      if (value) {
        this.dialog = false;
      } else {
        this.dialog = true;
      }
    },
    searchInfoCarTitle(value) {
      if (this.suppressCustomInfoCarTitleSearch) {
        return;
      }

      if (value) {
        this.loadingCustomInfoCarTitle = true;
        getRequest(
          "/info-car/parts",
          `title=${value}&language=${this.$store.getters.language}&all=true`,
        )
          .then((response) => {
            this.infoCarTitles = response.parts;
          })
          .catch(() => (this.loadingCustomInfoCarTitle = false))
          .finally(() => {
            this.loadingCustomInfoCarTitle = false;
            this.customInfoCarTitleMenuOpen =
              !!value && this.infoCarTitles.length > 0;
          });
      } else {
        this.infoCarTitles = [];
        this.customInfoCarTitleMenuOpen = false;
      }
    },
    customInfoCarTitle(value) {
      if (value) {
        this.closeCustomInfoCarTitleMenu();
        this.suppressCustomInfoCarTitleSearch = true;
        this.searchInfoCarTitle =
          value.title?.[this.$store.getters.language] || "";
        this.$nextTick(() => {
          this.suppressCustomInfoCarTitleSearch = false;
        });
        this.applyCustomInfoCarStub();
      } else {
        this.customInfoCarPosition = "S000";
        if (this.part) {
          delete this.part.infoCar;
        }
      }
    },
    customInfoCarPosition() {
      if (this.customInfoCarTitle) {
        this.applyCustomInfoCarStub();
      }
    },
    brand(value) {
      if (value) {
        this.models = [];
        this.model = null;
        this.versions = [];
        this.version = null;
        // Make sure that we don't get the models if we are searching for a license plate.

        // this.brand = value.brandCode;
        this.getModels(value.brandCode);
      } else {
        // this.brand = null;
      }
    },
    model(value) {
      if (value) {
        this.versions = [];
        this.version = null;
        // Make sure that we don't get the versions if we are searching for a license plate.
        this.getVersions(value.brandCode, value.modelCode);
        // this.model = value.modelCode;
        // Set year rule.
        this.setYearRule(value.startingDate, value.endingDate);
      } else {
        this.model = null;
      }
    },
    version(value) {
      if (value) {
        // this.version = value.versionCode;
        // Set year rule.
        this.setYearRule(value.startingDate, value.endingDate);
      } else {
        this.version = null;
      }
    },
  },
  mounted() {
    this.getBrands();
    this.setYearRule();
    window.addEventListener(
      "keydown",
      this.onWindowKeydownForCustomTitle,
      true,
    );
  },
  beforeUnmount() {
    window.removeEventListener(
      "keydown",
      this.onWindowKeydownForCustomTitle,
      true,
    );
  },
  methods: {
    open(data) {
      this.part = data;
      if (this.part.rrExport !== false) this.part.rrExport = true;
      if (this.part.exportEbay !== false) this.part.exportEbay = true;
      this.dialog = true;
      this.getTests();
      if (this.locksApprovePart) {
        this.postActivePart(data._id);
      } else {
        this.lockConflict = null;
      }
      this.loadingInfoCar = false;
      this.preloadImages();
      // this.getImages(data);
      // this.getTitleFromImage(data);
    },
    close() {
      if (this.locksApprovePart && this.part && this.part._id) {
        this.removeActivePart(this.part._id);
      }
      this.dialog = false;
      this.part = {};
      this.infoCarResult = [];
      this.selectedInfoCar = null;
      this.infoCarCode = null;
      this.customInfoCarTitle = null;
      this.customInfoCarPosition = "S000";
      this.searchInfoCarTitle = null;
      this.infoCarTitles = [];
      this.found = false;
      this.tests = [];
      this.$emit("close");
      this.selectedImage = null;
      this.loadingInfoCar = false;
      this.loadingImages = false;
      this.closeCustomInfoCarTitleMenu();
    },
    save() {
      putRequest("/temporary-part/approve/save", "", {
        part: this.part,
        userId: this.$store.getters.userId,
        institutionId: this.$store.getters.institutionId,
      })
        .then(() => {
          this.loadingSave = false;
          this.$emit("save");
          this.close();
        })
        .catch(() => {
          this.loadingSave = false;
          this.close();
        });
    },
    normalizePartAudio(audio) {
      if (audio == null) return null;
      if (typeof audio === "string") return audio;
      if (typeof audio === "object" && "exists" in audio) {
        return audio.exists ? audio.title : null;
      }
      return null;
    },
    approve() {
      this.loadingApprove = true;
      if (
        this.selectedInfoCar &&
        !this.selectedInfoCar.description.descriptionId
      ) {
        this.alert1.type = "error";
        this.alert1.message = "approve_error";
        this.alert1.value = true;
        setTimeout(() => {
          this.alert1.value = false;
          this.alert1.message = "";
        }, 5000);
        this.loadingApprove = false;
        return;
      }
      this.part.infoCar = {
        /* WARNING!
         * Do not send applicability because the payload gets too large.
         */
        _id: this.selectedInfoCar._id,
        oemCode: this.selectedInfoCar.oemCode,
        price: this.selectedInfoCar.price,
        description: this.selectedInfoCar.description,
        replacementCodes: this.selectedInfoCar.replacementCodes,
        kTypes: this.selectedInfoCar.kTypes,
        metadata: this.selectedInfoCar.metadata,
      };

      this.part.ebayShippingPrice =
        this.selectedInfoCar.description.descriptionId.ebayShippingReferencePrice; // eslint-disable-line max-len

      putRequest("/temporary-part/approve-new/", "", {
        part: {
          ...this.part,
          audio: this.normalizePartAudio(this.part.audio),
        },
        userId: this.$store.getters.userId,
        institutionId: this.$store.getters.institutionId,
      })
        .then((response) => {
          this.loadingApprove = false;
          this.$emit("approve");
          const ebayErrorObject = response.data.find((item) => item.ebayError);
          if (
            ebayErrorObject &&
            ebayErrorObject.ebayError &&
            ebayErrorObject.ebayError != null
          ) {
            this.$emit("show-error-modal", ebayErrorObject.ebayError);
          }
          this.close();
        })
        .catch(() => {
          this.loadingApprove = false;
          this.close();
        });
    },
    refuse() {
      this.loadingRefuse = true;
      putRequest("/temporary-part/approve/refuse", "", {
        part: this.part,
        userId: this.$store.getters.userId,
        institutionId: this.$store.getters.institutionId,
      })
        .then(() => {
          this.loadingRefuse = false;
          this.$emit("refuse");
          this.close();
        })
        .catch(() => {
          this.loadingRefuse = false;
          this.close();
        });
    },
    review() {
      this.loadingReview = true;
      putRequest("/temporary-part/approve/review", "", {
        part: this.part,
        userId: this.$store.getters.userId,
        institutionId: this.$store.getters.institutionId,
      })
        .then(() => {
          this.loadingReview = false;
          this.$emit("review");
          this.close();
        })
        .catch(() => {
          this.loadingReview = false;
          this.close();
        });
    },
    searchCode() {
      // Search code.
      this.selectedInfoCar = null;
      this.loadingInfoCar = true;
      getRequest("/info-car/search/", `code=${this.infoCarCode}&populated=true`)
        .then((response) => {
          this.loadingInfoCar = false;
          this.infoCarResult = response;
          [this.selectedInfoCar] = response;
          this.found = true;
        })
        .catch((error) => {
          this.alert.type = "error";
          this.alert.message = error.response.data || error;
          this.alert.value = true;
          this.loadingInfoCar = false;
          this.infoCarResult = [];
          this.found = false;
          setTimeout(() => {
            this.alert.value = false;
            this.alert.message = "";
          }, 3000);
        });
    },
    searchByManufacturer() {
      // Find InfoCar code by searching Parts by Manufacturer Code.
      this.loadingManufacturer = true;
      getRequest("/part/manufacturer", `code=${this.part.manufacturer_code}`)
        .then((response) => {
          this.infoCarCode = response.code;
          this.searchCode();
        })
        .catch(() => {
          this.activateAlert(
            "warning",
            this.$t("leko_employees.approve_parts.code_not_found"),
          );
        })
        .finally(() => {
          this.loadingManufacturer = false;
        });
    },
    getTests() {
      getRequest("/test")
        .then((response) => {
          this.tests = response.tests;
        })
        .catch(() => {});
    },
    // postActivePart(id) {
    //   /* Save part's id to activeParts collection, to indicate if an user is currently
    //    ** editing the part.
    //    */
    //   postRequest
    //     .object("/active-part/", { part_id: id })
    //     .then((res) => {
    //    if(res){
    //     this.isEditing = true;
    //    }
    //     })
    //     .catch(() => {});
    // },
    // removeActivePart(id) {
    //   deleteRequest("/active-part/", `id=${id}`)
    //     .then((res) => {
    //       if(res){
    //         this.isEditing = false;
    //       }
    //     })
    //     .catch(() => {});
    // },
    postActivePart(id) {
      postRequest
        .object("/active-part/v2", {
          part_id: id,
          user_id: this.$store.getters.userId,
        })
        .then(() => {
          this.isEditing = true;
          this.lockConflict = null;
        })
        .catch((err) => {
          if (err.response && err.response.status === 409) {
            this.lockConflict = err.response.data;
          }
        });
    },
    removeActivePart(id) {
      deleteRequest(
        "/active-part/v2",
        `id=${id}&user_id=${this.$store.getters.userId}`,
      )
        .then(() => {
          this.isEditing = false;
          this.lockConflict = null;
        })
        .catch(() => {});
    },
    viewImage(data) {
      this.$emit("open-img-dialog", data);
    },
    onWindowKeydownForCustomTitle(event) {
      if (!this.dialog) {
        return;
      }

      const isFindShortcut =
        (event.ctrlKey || event.metaKey) &&
        event.key.toLowerCase() === "f";
      if (!isFindShortcut) {
        return;
      }

      const fieldEl = this.$refs.customInfoCarTitleField?.$el;
      const isFieldFocused = fieldEl?.contains(document.activeElement);
      if (!isFieldFocused && !this.customInfoCarTitleMenuOpen) {
        return;
      }

      this.pinCustomInfoCarTitleMenu = true;
      if (this.infoCarTitles.length > 0) {
        this.customInfoCarTitleMenuOpen = true;
      }
    },
    onApproveFormMouseDown(event) {
      if (!this.customInfoCarTitleMenuOpen) {
        return;
      }

      const fieldEl = this.$refs.customInfoCarTitleField?.$el;
      if (fieldEl?.contains(event.target)) {
        return;
      }

      if (event.target.closest?.(".v-overlay__content")) {
        return;
      }

      this.closeCustomInfoCarTitleMenu();
    },
    onCustomInfoCarTitleKeydown(event) {
      if (event.key === "Escape") {
        this.closeCustomInfoCarTitleMenu();
      }
    },
    onCustomInfoCarTitleFocus() {
      if (this.searchInfoCarTitle && this.infoCarTitles.length > 0) {
        this.customInfoCarTitleMenuOpen = true;
      }
    },
    applyCustomInfoCarStub() {
      if (!this.customInfoCarTitle || !this.part) {
        return;
      }
      const positionCode = this.customInfoCarPosition || "S000";
      this.part.infoCar = {
        description: {
          descriptionCode: this.customInfoCarTitle.partCode,
          positionCode,
          descriptionId: this.customInfoCarTitle._id,
        },
      };
    },
    clearCustomInfoCarTitle() {
      this.customInfoCarTitle = null;
      this.customInfoCarPosition = "S000";
      this.searchInfoCarTitle = "";
      this.infoCarTitles = [];
      this.closeCustomInfoCarTitleMenu();
    },
    selectCustomInfoCarTitle(item) {
      this.customInfoCarTitle = item;
    },
    highlightInfoCarTitle(title, search) {
      const text = title || "";
      if (!search) {
        return `<span class="v-autocomplete__unmask">${text}</span>`;
      }

      const index = text
        .toLocaleLowerCase()
        .indexOf(search.toLocaleLowerCase());
      if (index === -1) {
        return `<span class="v-autocomplete__unmask">${text}</span>`;
      }

      return [
        `<span class="v-autocomplete__unmask">${text.slice(0, index)}</span>`,
        `<span class="v-autocomplete__mask">${text.slice(index, index + search.length)}</span>`,
        `<span class="v-autocomplete__unmask">${text.slice(index + search.length)}</span>`,
      ].join("");
    },
    closeCustomInfoCarTitleMenu() {
      this.pinCustomInfoCarTitleMenu = false;
      this.customInfoCarTitleMenuOpen = false;
    },
    preloadImages() {
      if (!this.part.images || this.part.images.length === 0) {
        this.loadingImages = false;
        return;
      }

      this.loadingImages = true;
      const urls = this.part.images.map(
        (image) => `${this.server}/images/?q=${image.thumb}`,
      );

      Promise.all(
        urls.map(
          (url) =>
            new Promise((resolve) => {
              const img = new Image();
              img.onload = resolve;
              img.onerror = resolve;
              img.src = url;
            }),
        ),
      ).finally(() => {
        this.loadingImages = false;
      });
    },
    async viewAllImages(data) {
      this.$emit("images", {
        type: "string",
        id: data._id,
        images: data.images,
        date: data.date_created,
      });
    },
    activateAlert(type, message) {
      this.alert.type = type;
      this.alert.message = message;
      this.alert.value = true;
      setTimeout(() => {
        this.alert.value = false;
      }, 2000);
    },
    addOemCode() {
      this.part.oemCodes.push(this.oemCode);
      this.oemCode = null;
    },
    removeOemCode(index) {
      this.part.oemCodes.splice(index, 1);
    },

    setSelectedImage(image) {
      if (this.selectedImage && this.selectedImage.image === image.image) {
        // Deselect the image if it's already selected
        this.selectedImage = null;
      } else {
        // Select the new image
        this.selectedImage = image;
      }
    },
    isSelected(image) {
      return this.selectedImage && this.selectedImage.image === image.image;
    },
    autoBotApi(part) {
      const title = part.classificationWithAI;
      this.loading = true;
      // const { selectedImage } = this;
      // if (!selectedImage) {
      //   this.loading = false;
      //   return;
      // }
      const partId = this.part._id;
      const requestBody = {
        title,
        // selectedImage: selectedImage
      };

      postRequest
        .object(`/temporary-part/applicability/${partId}`, requestBody)
        .then((response) => {
          // Update the infoCarCode property
          this.infoCarCode = response.data.oemCodeForPart;
          if (this.infoCarCode !== undefined) {
            // eslint-disable-next-line max-len
            const codesToAdd =
              response.data.top3IndividualCodes &&
              response.data.top3IndividualCodes.length > 0
                ? response.data.top3IndividualCodes
                : [response.data.oemCodeForPart];

            // Add elements to part.oemCodes
            this.part.oemCodes.push(...codesToAdd);
            this.searchCode();
            this.loading = false;
          } else {
            this.loading = false;
            this.alert = {
              value: true,
              type: "error",
              message: "parts.oem_not_found",
            };
            setTimeout(() => {
              this.alert.value = false;
            }, 5000);
          }
        })
        .catch((err) => {
          if (err) {
            this.loading = false;
            this.alert = {
              value: true,
              type: "error",
              message: "parts.oem_not_found",
            };
            setTimeout(() => {
              this.alert.value = false;
            }, 5000);
          }
        });
    },
    dragStartHandler(e) {
      this.draggingIndex = parseInt(
        e.currentTarget.getAttribute("data-index"),
        10,
      );
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/html", null);
    },
    dropHandler(e) {
      this.dropIndex = parseInt(e.currentTarget.getAttribute("data-index"), 10);
      if (this.draggingIndex !== this.dropIndex) {
        const draggedImage = this.part.images[this.draggingIndex];
        this.part.images.splice(this.draggingIndex, 1);
        this.part.images.splice(this.dropIndex, 0, draggedImage);
      }
      this.draggingIndex = -1;
      this.dropIndex = -1;
    },
    dragEndHandler() {
      this.draggingIndex = -1;
      this.dropIndex = -1;
    },
    getPosition(code) {
      switch (code) {
        case "S001":
          return this.$t("left");
        case "S002":
          return this.$t("right");
        default:
          return "";
      }
    },
    setYearRule(startingDate, endingDate) {
      const startingYear = startingDate
        ? new Date(startingDate).getFullYear()
        : 1900;
      const endingYear = endingDate
        ? new Date(endingDate).getFullYear()
        : new Date().getFullYear();
      this.yearRule = (v) =>
        (v >= startingYear && v <= endingYear) ||
        this.$t("parts.advanced_search.year_error");
    },

    getBrands() {
      this.loadingBrand = true;
      getRequest("/info-car/brands")
        .then((response) => {
          this.brands = response.brands;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingBrand = false;
        });
    },
    getModels(brandCode) {
      this.loadingModel = true;
      getRequest("/info-car/models", `brand_code=${brandCode}`)
        .then((response) => {
          this.models = response.models;
          this.filterModels();
        })
        .catch(() => {})
        .finally(() => {
          this.loadingModel = false;
        });
    },
    getVersions(brandCode, modelCode) {
      this.loadingVersion = true;
      getRequest(
        "/info-car/versions",
        `brand_code=${brandCode}&model_code=${modelCode}`,
      )
        .then((response) => {
          this.versions = response.versions;
          this.filterVersions();
        })
        .catch(() => {})
        .finally(() => {
          this.loadingVersion = false;
        });
    },
    filterModels() {
      if (
        this.year &&
        this.year.length === 4 &&
        this.models &&
        this.models.length > 0
      ) {
        this.models = this.models.filter((model) => {
          const sYear = model.startingDate
            ? new Date(model.startingDate).getFullYear()
            : 1900;
          const eYear = model.endingDate
            ? new Date(model.endingDate).getFullYear()
            : new Date().getFullYear();

          return this.year >= sYear && this.year <= eYear;
        });
      }
    },
    filterVersions() {
      if (
        this.brand &&
        this.brand.brandCode &&
        this.model &&
        this.model.modelCode &&
        this.versions &&
        this.versions.length > 0
      ) {
        if (this.year) {
          // filter by year
          this.versions = this.versions.filter((version) => {
            const sYear = version.startingDate
              ? new Date(version.startingDate).getFullYear()
              : 1900;
            const eYear = version.endingDate
              ? new Date(version.endingDate).getFullYear()
              : new Date().getFullYear();

            return this.year >= sYear && this.year <= eYear;
          });
        }

        if (this.supply) {
          // filter by supply
          this.versions = this.versions.filter(
            (version) => version.supplyCode === this.supply,
          );
        }
      }
    },
    saveCustomApplicability() {
      this.loadingCustom = true;
      let requestBody = {
        infoCarId: this.selectedInfoCar._id,
        brandCode: this.brand.brandCode,
        modelCode: this.model.modelCode,
        versionCode: this.version.versionCode,
      };
      postRequest
        .object(`/info-car/manual-update`, requestBody)
        .then((response) => {
          if (response && response.data) {
            this.loadingCustom = false;
            this.alert2 = {
              type: "success",
              message: this.$t("institutions.form.success"),
            };
            this.alert2.value = true;
            setTimeout(() => {
              this.alert2.value = false;
              this.selectedInfoCar = response.data.infoCar;
            }, 3000);
          }
        })
        .catch((err) => {
          if (err) {
            this.loadingCustom = false;
            this.alert2 = {
              type: "error",
              message: "Error!",
            };
            this.alert2.value = true;
            setTimeout(() => {
              this.alert2.value = false;
            }, 3000);
          }
        });
    },
    formatMonthYear(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // months are 0-indexed
      const year = date.getUTCFullYear();
      return `${month}/${year}`;
    },
    getSupplyLocale(supply) {
      switch (supply) {
        case "B":
          return this.$t("parts.advanced_search.supply.petrol");
        case "D":
          return this.$t("parts.advanced_search.supply.diesel");
        case "G":
          return this.$t("parts.advanced_search.supply.gas");
        default:
          return supply;
      }
    },
  },
};
</script>

<style scoped>
/* Model/version combobox mobile layout */
@media (max-width: 959px) {
  .approve-actions-dialog-root .car-version-detail-selection {
    width: 100%;
    padding: 0.375rem 0.25rem;
  }

  .approve-actions-dialog-root .car-version-detail-row {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    width: 100%;
    gap: 0.75rem 1rem;
  }

  .approve-actions-dialog-root .car-version-detail-col {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    min-width: 0;
    flex: 1 1 0;
  }

  .approve-actions-dialog-root .car-version-detail-col .caption {
    line-height: 1.25;
    margin-bottom: 0.125rem;
  }

  .approve-actions-dialog-root .car-version-detail-col .font-weight-bold {
    line-height: 1.4;
    word-break: break-word;
  }

  .approve-actions-dialog-root .car-search-combobox :deep(.v-field) {
    --v-field-padding-top: 10px;
    --v-field-padding-bottom: 10px;
    height: auto !important;
    min-height: 3.5rem;
  }

  .approve-actions-dialog-root .car-search-version-combobox :deep(.v-field) {
    --v-field-padding-top: 12px;
    --v-field-padding-bottom: 12px;
    min-height: 4.5rem;
  }

  .approve-actions-dialog-root .car-search-combobox :deep(.v-field__field) {
    height: auto !important;
    min-height: 3.5rem;
    align-items: flex-start;
  }

  .approve-actions-dialog-root .car-search-version-combobox :deep(.v-field__field) {
    min-height: 4.5rem;
  }

  .approve-actions-dialog-root .car-search-combobox :deep(.v-field__input) {
    white-space: normal;
    overflow: visible;
    align-items: flex-start;
    flex-wrap: wrap;
    min-height: unset;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .approve-actions-dialog-root .car-search-version-combobox :deep(.v-field__input) {
    display: block !important;
    height: auto !important;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .approve-actions-dialog-root .car-search-combobox :deep(.v-combobox__selection) {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    width: 100%;
    max-width: 100%;
  }

  .approve-actions-dialog-root .car-search-version-combobox :deep(.v-combobox__selection) {
    display: block !important;
    width: 100%;
    position: static !important;
    transform: none !important;
  }

  .approve-actions-dialog-root .car-detail-selection {
    overflow: visible;
    width: 100%;
  }


  .approve-actions-dialog-root .car-version-detail-row,
  .approve-actions-dialog-root .car-version-detail-row--dropdown {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem 0.875rem;
    flex-wrap: unset;
  }

  .approve-actions-dialog-root .car-version-detail-col {
    flex: unset;
    padding: 0;
  }

  .approve-actions-dialog-root .car-version-detail-col--main {
    grid-column: 1 / -1;
    padding-bottom: 0.625rem;
    margin-bottom: 0.25rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }

  .approve-actions-dialog-root .car-version-detail-col--main .font-weight-bold {
    line-height: 1.45;
  }

  .approve-actions-dialog-root .car-detail-col {
    flex: 1 1 calc(50% - 0.5rem);
    max-width: none;
    min-width: 0;
    padding: 0;
    word-break: break-word;
  }

  .approve-actions-dialog-root .car-detail-selection.d-flex {
    flex-wrap: wrap;
    gap: 0.625rem 0.75rem;
  }
}

.images-section {
  min-height: 150px;
}

.images-loader {
  min-height: 150px;
}

.custom-info-car-title-menu :deep(.v-autocomplete__mask) {
  background: rgb(var(--v-theme-surface-light));
}

.custom-info-car-position :deep(.v-messages) {
  color: rgb(var(--v-theme-error));
  opacity: 1;
}
</style>
